import { useAtomValue } from 'jotai';

import { useObscuredContentProps } from '../../a11y';
import { drawerStateAtom } from '../state';

/**
 * See `useObscuredContentProps` for more information.
 */
export function useObscuredProviderContentProps() {
  const isDrawerOpen = !!useAtomValue(drawerStateAtom);

  return useObscuredContentProps({
    isDrawerOpen,
  });
}
